export const statesMoodle = {
    ERROR: 0,
    OK: 1,
    USUARIO_EXISTENTE: 1
}

